import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const StickyCard = ({
    i,
    children,
    progress,
    range,
    targetScale,
}: {
    i: number;
    children: React.ReactNode;
    progress: any;
    range: [number, number];
    targetScale: number;
}) => {
    const container = useRef<HTMLDivElement>(null);
    const scale = useTransform(progress, range, [1, targetScale]);

    return (
        <div ref={container} className="sticky top-12 flex items-center justify-center px-4 h-screen w-full">
            <motion.div
                style={{
                    scale,
                    // Offset each subsequent card slightly lower so they stack nicely
                    top: `calc(${i * 20}px)`,
                }}
                className="relative origin-top flex flex-col w-full max-w-sm"
            >
                {children}
            </motion.div>
        </div>
    );
};

export const StickyScrollingCards = ({ items }: { items: React.ReactNode[] }) => {
    const container = useRef<HTMLDivElement>(null);
    const { scrollYProgress } = useScroll({
        target: container,
        offset: ["start start", "end end"],
    });

    return (
        <div
            ref={container}
            className="relative flex w-full flex-col items-center justify-center pb-[10vh]"
        >
            {items.map((item, i) => {
                const targetScale = Math.max(0.6, 1 - (items.length - i - 1) * 0.05);
                // The crucial fix: calculate the exact scroll percentage where THIS card hits the top.
                // It hits the top after `i * 100vh` of scrolling.
                // Using (i / (N - 1)) ensures it only starts shrinking AFTER it has safely stuck to the top.
                const rangeStart = i === items.length - 1 ? 0 : i / (items.length - 1);
                
                return (
                    <StickyCard
                        key={`p_${i}`}
                        i={i}
                        progress={scrollYProgress}
                        range={[rangeStart, 1]}
                        targetScale={targetScale}
                    >
                        {item}
                    </StickyCard>
                );
            })}
        </div>
    );
};
